import React from "react";

import * as Yup from "yup";
import { Link as RouterLink, useNavigate } from "react-router-dom";

// form
import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
// @mui
import {
  Link,
  Stack,
  IconButton,
  InputAdornment,
  Alert,
  Snackbar,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// components
import Iconify from "../../../components/Iconify";
import {
  FormProvider,
  RHFTextField,
  RHFCheckbox,
} from "../../../components/hook-form";
// import { postDataApi } from "../../../utils/apis";
//redux
import { useDispatch, useSelector } from "react-redux";
import { getUserEntity, login } from "../../../redux/features/authSlice";
import {
  ComponentType,
  EntityType,
  RegistrationStatus,
  UserType,
} from "../../../common/enum";
import Modal from "../../../components/Modal";
import ProfileSelector from "../ProfileSelector";
import { signInAnonymously } from "firebase/auth";
import { firebaseAuth } from "../../../firebase";

// ----------------------------------------------------------------------

export default function LoginForm({ t }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    loading,
    user: {entityId}
  } = useSelector((state) => state.auth);

  const [showPassword, setShowPassword] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [content, setContent] = React.useState("");
  const [modelTitle, setModelTitle] = React.useState("");
  const [modelConfirmButton, setModelConfirmButton] = React.useState(false);
  const [profileModelOpen, setProfileModelOpen] = React.useState(false);

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Insira um e-mail válido")
      .required(t("emailRequired")),
    password: Yup.string().required(t("passwordRequired")),
    // .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/, {message: "Password should be minimum 8 in length and at least one letter and number", excludeEmptyString: false}),
  });

  const defaultValues = {
    email: "",
    password: "",
    remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
    setError,
  } = methods;

  const handleClose = React.useCallback(() => {
    setModalOpen(false);
  }, []);

  const firebaseAnonomousLogin = async () => {
    try {
      const res = await signInAnonymously(firebaseAuth);
     // console.log('Login anônimo bem-sucedido', res);
    } catch (error) {
     // console.error('Erro durante o login anônimo', error);
    }
  };

  const onSubmit = async (data) => {
    try {
      data.email = data.email.toLowerCase();

      const response = await dispatch(login({ data })).unwrap();

      switch (response.status) {
        case RegistrationStatus.registering:
            navigate("/multistep", { replace: true });
            break;
          case RegistrationStatus.active:
            dispatch(getUserEntity(response.entityId))
              .unwrap()
              .then(async (successResult) => {
                if (successResult.userType === UserType.gppAdmin) {
                  navigate("/admin", { replace: true });
                } else {
                  if (
                    successResult.entity.entityType ===
                    EntityType.donorDistributor
                  ) {
                    setProfileModelOpen(true);
                  } else {
                    navigate("/dashboard", { replace: true });
                  }
                  await firebaseAnonomousLogin();
                }
              });
            break;
          case RegistrationStatus.rejected:
            setModalOpen(true);
            setContent(t("rejectModalContent"));
            setModelTitle(t("requestStatus"));
            break;
          case RegistrationStatus.pendingEmailVerification:
            setModalOpen(true);
            setContent(t("pendingEmailVerificationContent"));
            setModelTitle(t("requestStatus"));
            break;
          case RegistrationStatus.pendingApproval:
            setModalOpen(true);
            setContent(t("pendingModalContent"));
            setModelTitle(t("requestStatus"));
            break;
          case RegistrationStatus.inAtivo:
            setModalOpen(true);
            setContent(t("inActiveModalContent"));
            setModelConfirmButton(true);
            setModelTitle(t("requestInActiveStatus"));
            break;
          case RegistrationStatus.inActive:
            setModalOpen(true);
            setContent(t("inActiveModalContent"));
            setModelConfirmButton(true);
            setModelTitle(t("requestInActiveStatus"));
            break;
          case RegistrationStatus.revoked:
            setModalOpen(true);
            setContent(t("inActiveModalContent"));
            setModelConfirmButton(true);
            setModelTitle(t("requestInActiveStatus"));
            break;
          case RegistrationStatus.registering:
            navigate("/multistep", { replace: true });
            break;
          default:
            break;
      }

    } catch (error) {
      if (error.code === "ERR_BAD_REQUEST") {
        setError("email", {
          type: "AuthFail",
          message: t("wrongPassOrEmailMsg"),
        });
      }
  }

    
  };
  const handleConfirm = (e) => {
    dispatch(getUserEntity(entityId))
      .unwrap()
      .then(async (successResult) => {
        try {
          if (successResult.entity.entityType === EntityType.donorDistributor) {
            setProfileModelOpen(true);
          } else {
            navigate("/dashboard");
          }
          await firebaseAnonomousLogin();
          setModalOpen(false);
        } catch (error) {
          console.error("Error in handleConfirm:", error);
        }
      });
  };

  return (
    <>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3}>
          <RHFTextField name="email" label={t("emailAddress")} />

          <RHFTextField
            name="password"
            label={t("password")}
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? t("hidePassword") : t("showPassword")}
                    edge="end"
                  >
                    <Iconify
                      icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"}
                      aria-hidden="true"
                    />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ my: 2 }}
        >
          {/* <RHFCheckbox name="remember" label={t("rememberMe")} /> */}

          <Link
            variant="subtitle2"
            underline="hover"
            component={RouterLink}
            to="/verify-email"
          >
            {t("forgotPassword")}
          </Link>
        </Stack>
        <LoadingButton
          sx={{
            borderRadius: "4px",
          }}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={loading}
        >
          {t("loginbutton")}
        </LoadingButton>
        {/* <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
        >
          <Alert
            onClose={() => setOpen(false)}
            severity="success"
            sx={{ width: "100%" }}
          >
            {t("loginSuccess")}
          </Alert>
        </Snackbar> */}
      </FormProvider>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        title={modelTitle}
        content={content}
        isConfirm={modelConfirmButton}
        buttonTitle={t("loginConfirm")}
        handleConfirm={handleConfirm}
      />
      <ProfileSelector
        open={profileModelOpen}
        setOpen={setProfileModelOpen}
        component={ComponentType.LOG_IN}
        t={t}
      />
    </>
  );
}
